import { render, staticRenderFns } from "./base-table-auto.vue?vue&type=template&id=06341e60&scoped=true&"
import script from "./base-table-auto.vue?vue&type=script&lang=js&"
export * from "./base-table-auto.vue?vue&type=script&lang=js&"
import style0 from "./base-table-auto.vue?vue&type=style&index=0&id=06341e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06341e60",
  null
  
)

export default component.exports